import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import {cartContext}from'../Contexts/CartContext';
function CartNotFound() {
    let nav=useNavigate();
    let {setcheck,check}=useContext(cartContext);
useEffect(() => {
  setcheck(false);
 
  setcheck(false);
    Swal.fire({title:'Info',text:'Your Cart Empty go to Fill It',icon:'info'}).then((result)=>{if(result.isConfirmed){nav('/home')
    }});
   
}, [])

    
  return <>
  
 
  
  </>
}

export default CartNotFound
